import { Button } from "primereact/button";

import { Report } from "interfaces";
import {
  buttonResolveReport,
  panelLabelResolvedBy,
  panelLabelResolvedTime,
} from "_constants";
import { useState } from "react";
import { ModalResolveReport } from "components/modals";
import { PrimeIcons } from "primereact/api";
import { formatDataSource } from "utils";

export const ReportDetailPanelFooter = ({ report }: { report: Report }) => {
  const [showModal, setShowModal] = useState(false);

  const openResolveReportModal = () => {
    setShowModal(true);
  };
  return (
    <>
      {report.state === "APERTA" ? (
        <>
          <div className="detail-panel-footer flex-container justify-end padd-18">
            <Button
              label={buttonResolveReport}
              type="button"
              onClick={openResolveReportModal}
            />
          </div>
          <ModalResolveReport
            showModal={showModal}
            report={report}
            onClose={() => setShowModal(false)}
          />
        </>
      ) : (
        <div className="detail-panel-footer flex-container padd-18 gap-4">
          {report.resolvedTime && (
            <>
              <i className={PrimeIcons.CALENDAR} />
              <span className="text-base-regular">
                {panelLabelResolvedTime}
              </span>
              <span className="text-base-regular-semibold capitalize">
                {formatDataSource(report.resolvedTime, true)}
              </span>
              <span className="text-base-regular">{panelLabelResolvedBy}</span>
              <span className="text-base-regular-semibold capitalize">
                {report.resolvedBy}
              </span>
            </>
          )}
        </div>
      )}
    </>
  );
};
